import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {
    IVoceSchedaCosto
} from "../../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceSchedaCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../../utils/contexts/auth-context";


const useApiGetVoceSchedaCostoDetail = (scheda_costo_id: number | undefined, pk: number | undefined): UseQueryResult<IVoceSchedaCosto, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IVoceSchedaCosto> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/schede_costo/${scheda_costo_id}/voci_scheda_costo/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetVoceSchedaCostoDetail", scheda_costo_id, pk],
        queryFn: () => doGet(pk),
        enabled: !!pk,
    })

};

export default useApiGetVoceSchedaCostoDetail